import { render, staticRenderFns } from "./ItemGuia.vue?vue&type=template&id=b2133f4c&scoped=true"
import script from "./ItemGuia.vue?vue&type=script&lang=js"
export * from "./ItemGuia.vue?vue&type=script&lang=js"
import style0 from "./ItemGuia.vue?vue&type=style&index=0&id=b2133f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2133f4c",
  null
  
)

export default component.exports